import { render, staticRenderFns } from "./ethernet.vue?vue&type=template&id=646139a1&scoped=true"
import script from "./ethernet.vue?vue&type=script&lang=js"
export * from "./ethernet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646139a1",
  null
  
)

export default component.exports